export type TPillarsOfStrengthProps = {
  id?: string;
  elcName?: string;
  onLevelSelected?: (level: any, subPillar: any, tactic?: any) => void;
};

export enum EPillarsOfStrengthTabs {
  COMMUNITIES = 'communities',
  SERVICES = 'services',
  NEIGHBORHOODS = 'neighborhoods',
  POLICY = 'policy',
}
